module.exports = __webpack_public_path__ + "static/media/live.4d13143e.svg";